/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_FaqInputs */

const en_landing_pricing_compare_faq = /** @type {(inputs: Landing_Pricing_Compare_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ + cited sources`)
};

const zh_landing_pricing_compare_faq = /** @type {(inputs: Landing_Pricing_Compare_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ 与来源引用`)
};

/**
* | output |
* | --- |
* | "FAQ + cited sources" |
*
* @param {Landing_Pricing_Compare_FaqInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_faq = /** @type {((inputs?: Landing_Pricing_Compare_FaqInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_FaqInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_faq(inputs)
	return zh_landing_pricing_compare_faq(inputs)
});
export { landing_pricing_compare_faq as "landing.pricing.compare_faq" }